import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e4415c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contain" }

import programChart from './programChart.vue';
import { useRouter,useRoute } from 'vue-router';
import { onMounted, ref,watch } from 'vue';
import javaapi from '@/service/javaapi';

interface projectNumInfoInterface{
    type: string;
    number: number;
    ongoing_num: number;
    paused_num: number;
    completed_num: number;
}



export default /*#__PURE__*/_defineComponent({
  __name: 'Program',
  setup(__props) {

onMounted( async () => {
  await init();
})

const projectNumList = ref([
  {
  "type": "",
  "number": 0,
  "ongoing_num": 0,
  "paused_num": 0,
  "completed_num": 0
  },
  {
  
  "type": "",
  "number": 0,
  "ongoing_num": 0,
  "paused_num": 0,
  "completed_num": 0
  },
  {
  
  "type": "",
  "number": 0,
  "ongoing_num": 0,
  "paused_num": 0,
  "completed_num": 0
  },
  {
  
  "type": "",
  "number": 0,
  "ongoing_num": 0,
  "paused_num": 0,
  "completed_num": 0
  },

])

const router = useRouter()
const route = useRoute()
const clickChart = (type) => {
  //console.log('点击了表：' + type)
  router.push({
    name: "ProgramContent",
    query: {
      type: type
    },
  });
}

watch(route, (newValue, oldValue) => {
  if (newValue.name === "Program"){
     init()
  }
});

const init = async () => {
    //console.log('初始化')
    let organization_id = localStorage.getItem("organization_id")
    let user_id = 0;
    const query = {
      jsonText:{"organization_id":organization_id},
      token: localStorage.getItem("token"),
      user_id:  parseInt(<string>localStorage.getItem("user_id")),
    }
    const result = await javaapi.postQuery(query,"/project/getProjectNum");
    //console.log(result)
    projectNumList.value.length = 0;
    if(result.status == '1'){
      projectNumList.value = [...result.data];
      //console.log(projectNumList.value)
    }

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "type1",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickChart(projectNumList.value[0].type)))
    }, [
      _createVNode(programChart, {
        type: projectNumList.value[0].type,
        number: projectNumList.value[0].number,
        ongoing_num: projectNumList.value[0].ongoing_num,
        completed_num: projectNumList.value[0].completed_num,
        paused_num: projectNumList.value[0].paused_num
      }, null, 8, ["type", "number", "ongoing_num", "completed_num", "paused_num"])
    ]),
    _createElementVNode("div", {
      class: "type2",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (clickChart(projectNumList.value[1].type)))
    }, [
      _createVNode(programChart, {
        type: projectNumList.value[1].type,
        number: projectNumList.value[1].number,
        ongoing_num: projectNumList.value[1].ongoing_num,
        completed_num: projectNumList.value[1].completed_num,
        paused_num: projectNumList.value[1].paused_num
      }, null, 8, ["type", "number", "ongoing_num", "completed_num", "paused_num"])
    ]),
    _createElementVNode("div", {
      class: "type3",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (clickChart(projectNumList.value[2].type)))
    }, [
      _createVNode(programChart, {
        type: projectNumList.value[2].type,
        number: projectNumList.value[2].number,
        ongoing_num: projectNumList.value[2].ongoing_num,
        completed_num: projectNumList.value[2].completed_num,
        paused_num: projectNumList.value[2].paused_num
      }, null, 8, ["type", "number", "ongoing_num", "completed_num", "paused_num"])
    ]),
    _createElementVNode("div", {
      class: "type4",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (clickChart(projectNumList.value[3].type)))
    }, [
      _createVNode(programChart, {
        type: projectNumList.value[3].type,
        number: projectNumList.value[3].number,
        ongoing_num: projectNumList.value[3].ongoing_num,
        completed_num: projectNumList.value[3].completed_num,
        paused_num: projectNumList.value[3].paused_num
      }, null, 8, ["type", "number", "ongoing_num", "completed_num", "paused_num"])
    ])
  ]))
}
}

})